<script>
	import { slide } from 'svelte/transition'
	import { onMount } from 'svelte'

	import LineItem from './LineItem.svelte'
	import LineItemControls from './LineItemControls.svelte'
	import GroupControls from './GroupControls.svelte'

	export let api, time, grouped_line_items

	let current_time = Date.now()
	onMount(() => {
		setInterval(() => { current_time = Date.now() }, 1000)
	})

	function restore_item(key) {
		// We don't restore groups
		api(`/item/restore`, { cart_item_key: key })
	}
</script>


{#each grouped_line_items as group (group.items[0].key)}
	{#if group.group_id}
		<div class="line-item-group border" transition:slide|global>
			<div class="line-items-in-group">
				{#each group.items as { key, item } (key)}
					<div class="line-item">
						<LineItem item={item}>
							<LineItemControls {item} />
						</LineItem>
					</div>
				{/each}
			</div>
			<GroupControls {api} {group} />
		</div>
	{:else}
		{#each group.items as { key, item } (key)}
			{#if !item.product}
				{#if (current_time - 15000) < time * 1000 }
					<div class="removed">
						{ item } removed.  <button type="button" class="subtle" on:click="{() => restore_item(key)}" style="margin-left: 5px;">Restore</button>
					</div>
				{/if}
			{:else}
				<div class="line-item-and-quantity border" transition:slide|global>
					<div class="line-item">
						<LineItem {item}>
							<LineItemControls {api} {key} {item} />
						</LineItem>
					</div>
				</div>
			{/if}
		{/each}
	{/if}
{/each}



<style>
	.line-items-in-group,
	.line-item-and-quantity,
	.line-item-group {
		display: flex;
		flex-direction: column;
	}

	.line-item {
		width: 100%;
		display: flex;
		flex-direction: row;
	}

	.line-items-in-group {
		width: 100%;
	}

	.line-item-and-quantity + .line-item-and-quantity,
	.line-item + .line-item {
		margin-top: 16px;
	}

	.border {
		border: 5px solid #333;
		border-radius: 6px;
		padding: 10px;
		margin: 16px 0;
	}

	button {
		cursor: pointer;
		font-size: 12px;
		font-weight: 500;
		text-transform: uppercase;
		-webkit-font-smoothing: antialiased;
		-webkit-appearance: none;
		appearance: none;
		text-decoration: none;
		padding: 8px 8px;
	}

	button.subtle {
		background-color: #333;
		color: #ccc;
		margin: 5px;
		border: 1px solid #333;
	}
	button.subtle:hover {
		border-color: #ccc;
	}

	button:focus-visible {
		outline: 3px solid #fff;
	}
</style>
